export default __webpack_public_path__ + "alberta-maxamount.2d626a21deda708c69b8.svg";